import React from 'react';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { createBaseGainsightProvider } from '@rsos/capstone';
import '@rsos/capstone/src/overridePublicPath';
import { gspx } from '@rsos/gainsight';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import App from './App';
import { store } from './state/store';

// Initialize Gainsight behavior tracking with data provider and error handling
const dataProvider = {
  ...createBaseGainsightProvider(store),
  // The keyword-_anagement app doesn't handle call data
  getSelectedCallData: () => null,
};
gspx.initialize(dataProvider, {
  captureError: captureExceptionWithScope,
});

const container = document.getElementById('root');
if (!container) {
  throw new ReferenceError('No #root container available');
}

const root = createRoot(container);

const render = (Component: () => JSX.Element) => root.render(<Component />);

render(App);
